<template>
  <div>
    <div class="col-md-10 mx-auto">
      <h1 class="display-4">{{ config.welcomeTitle }}</h1>
      <div v-html="config.welcomeText"></div>
      <!-- <p>
        Welkom, Linus, in onze wereld! We hebben lang op je gewacht en naar je uitgekeken, en daar was je plots.
      </p>
      <p>
        4 weken te vroeg, maar heel erg welkom, kunnen wij je nu in onze armen nemen.
      </p>
      <p>Wij kijken er naar uit je te leren kennen!</p>-->
      <br />
      <button
        class="btn btn-info"
        @click="$router.push('/config')"
        v-if="currentUser && currentUser.email"
      >
        Edit
      </button>

      <div class="mt-3 mb-5">
        <template v-for="(img, idx) in sortedCarousel">
          <a
            :href="img.img"
            target="_blank"
            :key="'homeImg_' + idx"
            :data-index="idx"
          >
            <progressive-img
              class="card-img-top img-fluid m-0 mt-2"
              :src="img.img"
              :placeholder="img.img_thumb"
              :aspect-ratio="img.ratio"
            ></progressive-img>
          </a>
          <span v-if="img.caption" class="mx-auto text-center">
            <i>{{ img.caption }}</i>
          </span>
        </template>
      </div>
      <!-- <div class="mb-3 embed-responsive embed-responsive-4by3">
        <video
          controls
          controlslist="nodownload nofullscreen noremoteplayback"
          autoplay
          inline
          disablepictureinpicture
          poster="https://firebasestorage.googleapis.com/v0/b/stijnenromy.appspot.com/o/homepage%2F7e5d85dd-a99f-240e-6964abc9?alt=media&token=e9212433-fc70-4a6a-9169-4d470f26fcad"
        >
          <source
            src="https://firebasestorage.googleapis.com/v0/b/stijnenromy.appspot.com/o/filmpjes%2Finput_file.mp4?alt=media&token=23dfce1b-e575-4ffb-9bf4-055293faeff0"
            type="video/mp4"
          />Your browser does not support the video tag.
        </video>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["homeCarousel", "currentUser", "config"]),
    sortedCarousel() {
      return this.$_.sortBy(this.homeCarousel, "order");
    },
  },
};
</script>

